export const validateNumeric = (str: string): boolean => {
    return /^\d+$/.test(str);
};

export const validateAlphaNumeric = (str: string): boolean => {
    return /^[a-zA-Z0-9]+$/.test(str);
};

export const validateLength = (str: string, length: number): boolean => {
    return str.length === length;
};
